import React, { createContext, useCallback, useContext, useEffect, useState } from "react";

const NavbarContext = createContext(null);

export const NavbarProvider = ({ children }) => {
  const [heading, setHeading] = useState("");
  const [subStoreVersion, setSubStoreVersion] = useState(0);
  const bumpSubStoreVersion = useCallback(() => setSubStoreVersion((v) => v + 1), []);

  return (
    <NavbarContext.Provider
      value={{ heading, setHeading, subStoreVersion, bumpSubStoreVersion }}
    >
      {children}
    </NavbarContext.Provider>
  );
};

export const useNavbarContext = () => useContext(NavbarContext);

// Drop-in replacement for the old `<Navbar heading="..." />` usage inside routed
// pages: sets the shared layout's heading for as long as this page is mounted.
export const SetHeading = ({ value }) => {
  const { setHeading } = useNavbarContext();
  useEffect(() => {
    setHeading(value);
  }, [value, setHeading]);
  return null;
};
